import { Languages, ProductCardType } from '@/constants'
import { useCart, useStore } from '@/containers'
import type { FlashSaleModal, PreOrderType } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { useTranslations } from 'next-intl'
import Countdown from '../ProductCard/Countdown'
import ProgressBar from '../ProgressBar'
interface PreOrderProps {
  type?: string
  originPrice: number
  preOrderPrice: number
  finalPrice: number
  priceAtWarehouse?: boolean
  hasGift?: boolean
  hasDeal?: boolean
  flashSale: FlashSaleModal
  productId: string
  className?: string
  layout?: string
  preOrder: PreOrderType
  priceDescription?: Record<string, string>
}

export const PreOrder = ({
  originPrice,
  finalPrice,
  flashSale,
  productId,
  preOrderPrice,
  hasGift,
  hasDeal,
  priceAtWarehouse,
  type,
  preOrder,
  priceDescription,
}: PreOrderProps) => {
  const { selectedLang } = useStore()
  const { setIsPreOrder } = useCart()
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'VND'
      default:
        return 'VND'
    }
  }
  const t = useTranslations('ProductDetail')

  const handlePreOrder = (e: { target: { value: string } }) => {
    if (e && e.target.value === 'preOrder') {
      return setIsPreOrder(true)
    }
    return setIsPreOrder(false)
  }
  const percent = Math.ceil(100 - (finalPrice / originPrice) * 100)
  const percentPreOrder = Math.ceil(100 - (preOrderPrice / originPrice) * 100)
  if (flashSale) {
    return (
      <>
        <div
          className={`price-wrapper grid w-full grid-cols-2 gap-2.5 rounded-xl bg-flash-sale bg-cover bg-center bg-no-repeat pt-2.5 pb-3 px-3`}
        >
          <div className='optionBuyFlashSale preOrderRadio normalPrice'>
            <input
              className='FlashSaleInput invisible'
              id={'normalPrice_' + productId}
              type='radio'
              value={'normal'}
              name='FlashSalePreOrder'
              onChange={handlePreOrder}
            />
            <label
              className='optionBuyContent flex-col relative flex cursor-pointer flex-wrap p-2'
              htmlFor={'normalPrice_' + productId}
            >
              <span className='flag'></span>
              {type === ProductCardType.PRODUCT_DETAIL && (
                <span className='textTop block text-xs font-bold leading-5 text-white'>
                  {priceDescription ? (
                    getTranslate(priceDescription)
                  ) : (
                    <>
                      {hasDeal
                        ? 'Giá DEAL độc quyền'
                        : priceAtWarehouse
                        ? t('warehousePrice')
                        : hasGift
                        ? 'Giá online rẻ hơn'
                        : t('priceWithShip')}
                    </>
                  )}
                  :
                </span>
              )}

              <div className='sale-price flex items-center justify-between'>
                <p className={`text-[22px] font-black leading-7 text-white`}>
                  {finalPrice &&
                    finalPrice
                      .toLocaleString(Languages.VN, {
                        style: 'currency',
                        currency: currency(selectedLang as string),
                      })
                      .replace(/\s₫/g, 'đ')}
                </p>
              </div>
              <div className='originPrice flex-start flex items-center gap-x-2'>
                <p
                  className={`${
                    type === 'product-detail'
                      ? 'text-sm font-normal leading-5 text-white'
                      : 'text-zinc-500'
                  } text-sm leading-normal line-through`}
                >
                  {originPrice &&
                    originPrice
                      .toLocaleString(Languages.VN, {
                        style: 'currency',
                        currency: currency(selectedLang as string),
                      })
                      .replace(/\s₫/g, 'đ')}
                </p>
                {percent > 0 && (
                  <span className='discount flex w-max items-baseline gap-[4px] rounded bg-red-500 text-xs py-[2px] leading-4 text-stone-50'>
                    <span className='flex items-center px-[4px] text-white'>
                      <span className='value'>{'-' + percent}</span>
                      <span className='unit'>%</span>
                    </span>
                  </span>
                )}
              </div>
            </label>
          </div>
          <div className='optionBuyFlashSale preOrderRadio preOrderPrice'>
            <input
              className='optionBuyInput invisible'
              id={'preOrderPrice_' + productId}
              type='radio'
              value={'preOrder'}
              name='FlashSalePreOrder'
              onChange={handlePreOrder}
              defaultChecked={true}
            />
            <label
              className='optionBuyContent flex-col relative flex cursor-pointer flex-wrap p-2'
              htmlFor={'preOrderPrice_' + productId}
            >
              <span className='flag'></span>
              {type === ProductCardType.PRODUCT_DETAIL && (
                <span className='textTop block text-xs font-bold leading-5 text-white'>
                  Đặt trước giao sau {preOrder?.deliveredAfter} ngày:
                </span>
              )}
              <div className='sale-price items-center justify-between first-line:flex'>
                <p className={`text-[22px] font-black leading-7 text-white`}>
                  {preOrder?.salePrice &&
                    preOrder?.salePrice
                      .toLocaleString(Languages.VN, {
                        style: 'currency',
                        currency: currency(selectedLang as string),
                      })
                      .replace(/\s₫/g, 'đ')}
                </p>
              </div>
              <div className='originPrice flex-start flex items-center gap-x-2'>
                <p
                  className={`${
                    type === 'product-detail'
                      ? 'text-sm font-normal leading-5 text-white'
                      : 'text-zinc-500'
                  } text-sm leading-normal line-through`}
                >
                  {originPrice &&
                    originPrice
                      .toLocaleString(Languages.VN, {
                        style: 'currency',
                        currency: currency(selectedLang as string),
                      })
                      .replace(/\s₫/g, 'đ')}
                </p>
                {percentPreOrder > 0 && (
                  <span className='discount flex w-max items-baseline gap-[4px] rounded bg-white text-xs py-[2px] leading-4 text-stone-50'>
                    <span className='flex items-center px-[4px] text-dark-400'>
                      <span className='value'>{'-' + percentPreOrder}</span>
                      <span className='unit'>%</span>
                    </span>
                  </span>
                )}
              </div>
            </label>
          </div>
        </div>
        <div className='wrapper mt-[2px] flex w-full items-center justify-between overflow-hidden rounded-xl bg-flash-sale bg-cover bg-center bg-no-repeat py-2 px-3'>
          <div className='countdown max-w-[120px] flex-50'>
            <Countdown
              productId={productId}
              endTime={flashSale?.endTime}
              type={'product-detail'}
            />
          </div>
          <div className='progressBar max-w-[160px] flex-50'>
            <ProgressBar flashSale={flashSale} type={'preOrder'} />
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div
        className={`price-wrapper grid w-full grid-cols-2 gap-2.5 rounded-xl bg-gray-1400 p-2.5 mt-3`}
      >
        <div className='optionBuy preOrderRadio normalPrice'>
          <input
            className='optionBuyInput invisible'
            id={'normalPrice_' + productId}
            type='radio'
            value={'normal'}
            name='optionBuyPreOrder'
            onChange={handlePreOrder}
          />
          <label
            className='optionBuyContent flex-col relative flex cursor-pointer flex-wrap p-2'
            htmlFor={'normalPrice_' + productId}
          >
            <span className='flag'></span>
            {type === ProductCardType.PRODUCT_DETAIL && (
              <span className='block text-xs font-bold leading-5 text-dark-400'>
                {priceDescription ? (
                  getTranslate(priceDescription)
                ) : (
                  <>
                    {priceAtWarehouse
                      ? t('warehousePrice')
                      : hasGift
                      ? 'Giá online rẻ hơn'
                      : t('priceWithShip')}
                  </>
                )}
                :
              </span>
            )}
            <div className='sale-price flex items-center justify-between'>
              <p className={`text-[22px] font-extrabold leading-7`}>
                {finalPrice &&
                  finalPrice
                    .toLocaleString(Languages.VN, {
                      style: 'currency',
                      currency: currency(selectedLang as string),
                    })
                    .replace(/\s₫/g, 'đ')}
              </p>
            </div>
            <div className='originPrice flex-start flex items-center gap-x-2'>
              <p
                className={`${
                  type === 'product-detail'
                    ? 'text-sm font-normal leading-5 text-zinc-500'
                    : 'text-zinc-500'
                } text-sm leading-normal line-through`}
              >
                {originPrice &&
                  originPrice
                    .toLocaleString(Languages.VN, {
                      style: 'currency',
                      currency: currency(selectedLang as string),
                    })
                    .replace(/\s₫/g, 'đ')}
              </p>
              {percent > 0 && (
                <span className='discount flex w-max items-baseline gap-[4px] rounded bg-red-500 text-xs py-[2px] leading-4 text-stone-50'>
                  <span className='flex items-center px-[4px] text-white'>
                    <span className='value'>{'-' + percent}</span>
                    <span className='unit'>%</span>
                  </span>
                </span>
              )}
            </div>
          </label>
        </div>
        <div className='optionBuy preOrderRadio preOrderPrice'>
          <input
            className='optionBuyInput invisible'
            id={'preOrderPrice_' + productId}
            type='radio'
            value={'preOrder'}
            name='optionBuyPreOrder'
            onChange={handlePreOrder}
            defaultChecked={true}
          />
          <label
            className='optionBuyContent flex-col relative flex cursor-pointer flex-wrap p-2'
            htmlFor={'preOrderPrice_' + productId}
          >
            <span className='flag'></span>
            {type === ProductCardType.PRODUCT_DETAIL && (
              <span className='block text-xs font-bold leading-5 text-dark-400'>
                Đặt trước giao sau {preOrder?.deliveredAfter} ngày:
              </span>
            )}
            <div className='sale-price items-center justify-between first-line:flex'>
              <p className={`text-[22px] font-extrabold leading-7`}>
                {preOrder?.salePrice &&
                  preOrder?.salePrice
                    .toLocaleString(Languages.VN, {
                      style: 'currency',
                      currency: currency(selectedLang as string),
                    })
                    .replace(/\s₫/g, 'đ')}
              </p>
            </div>
            <div className='originPrice flex-start flex items-center gap-x-2'>
              <p
                className={`${
                  type === 'product-detail'
                    ? 'text-sm font-normal leading-5 text-zinc-500'
                    : 'text-zinc-500'
                } text-sm leading-normal line-through`}
              >
                {originPrice &&
                  originPrice
                    .toLocaleString(Languages.VN, {
                      style: 'currency',
                      currency: currency(selectedLang as string),
                    })
                    .replace(/\s₫/g, 'đ')}
              </p>
              {percentPreOrder > 0 && (
                <span className='discount flex w-max items-baseline gap-[4px] rounded bg-red-500 text-xs py-[2px] leading-4 text-stone-50'>
                  <span className='flex items-center px-[4px] text-white'>
                    <span className='value'>{'-' + percentPreOrder}</span>
                    <span className='unit'>%</span>
                  </span>
                </span>
              )}
            </div>
          </label>
        </div>
      </div>
    )
  }
}

export default PreOrder
